import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { AllocationViewEndpoint } from '../../constants';
import { AllocationViewActionIdentifierModel, AllocationViewTruckReleaseModel } from '../../models';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AllocationViewTruckReleaseActionService {
  constructor(private http: WrapperHttpService) {}

  truckRelease(data: AllocationViewTruckReleaseModel): Observable<void> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Truck}${AllocationViewEndpoint.Release}`;

    return this.http.withLoading().post<void>(url, data);
  }

  truckReleasePrepare(
    actionIdentifier: AllocationViewActionIdentifierModel,
    currentLanguage: string,
  ): Observable<AllocationViewTruckReleaseModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Truck}${AllocationViewEndpoint.Release}${AllocationViewEndpoint.Prepare}?lang=${currentLanguage}`;

    return this.http.withLoading().post<AllocationViewTruckReleaseModel>(url, actionIdentifier);
  }
}
